import { get } from 'vio-libs';
export function getOrganizations(consumerAPI = false) {
    if (!consumerAPI) {
        return get('organizations');
    }
    return get('v1/orgs', undefined, true);
}
